import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { abTestActions } from '../../store';

const { ADD_AB_TEST } = abTestActions;

const useSetCustomABTest = (abTestName) => {
  const { abTests } = useOtherSettings();
  const requiredABTest = abTests?.find(({ name }) => name === abTestName);

  const setABTestVariant = () => {
    if (requiredABTest) {
      return ADD_AB_TEST(requiredABTest);
    }
    return null;
  };

  return setABTestVariant;
};

export default useSetCustomABTest;
